import { useEffect } from "react";
import { useLocation } from 'react-router-dom';

const Missing = () => {

    useEffect(() => {
        document.title = 'Fretless Finance | Page Not Found';
    }, []);

    return (
        <section style={{
            alignItems: 'center',
            height: '50vh'
        }}>
            <h1>Page Not Found!</h1>
        </section>
    );
}

export default Missing;